module.exports = __webpack_public_path__ + "static/media/photo_tradeshow_management.31032b19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SideImage/photo_tradeshow_management.jpg
// module id = 387
// module chunks = 0